//import * as types from 'constants/newsFeedConstants';
export const SUCCESS_DEFAULT = 'neo-trading/dashboard/SUCCESS_DEFAULT';
export const FAILURE_DEFAULT = 'neo-trading/dashboard/FAILURE_DEFAULT';
export const LOAD_NEWSFEED = 'neo-trading/dashboard/LOAD_NEWSFEED';
export const LOAD_NEWSFEED_SUCCESS = 'neo-trading/dashboard/LOAD_NEWSFEED_SUCCESS';
export const LOAD_NEWSFEED_FAILURE = 'neo-trading/dashboard/LOAD_NEWSFEED_FAILURE';
export const UPDATE_NEWSFEED ='neo-trading/dashboard/UPDATE_NEWSFEED';
const initialState = {
  newsFeedData:[]
};
const updateNewsFeedData = (newsFeedData,message) =>{
  const item =Object.assign([],newsFeedData);
  const msg=message.data;
  if(msg.PT="A"){
    var obj={};
    obj.nf_id=msg.ID;
    obj.NF=msg.MSG;
    obj.URL=msg.URL;
    obj.CT=parseFloat(msg.TS);
    item.push(obj);
  }
  if(msg.PT="E"){
    let index1;
    let index;
      for (let index = 0; index < item.length; index++) {
          if (item[index].nf_id === msg.ID) {
                item[index].NF=msg.NF;
                item[index].URL=msg.URL;
                item[index].CT=parseFloat(msg.TS);
                item[index]=msg;
            }
      }
  }
localStorage.setItem('newsFeedData', JSON.stringify(item));
};
export default function(state = initialState, action)  {
  switch (action.type) {
    case SUCCESS_DEFAULT:
      return {
        ...state
      };
    case FAILURE_DEFAULT:
      return {
        ...state
      };
    case LOAD_NEWSFEED:
        return {
        ...state
      };
    case LOAD_NEWSFEED_SUCCESS:
        return {
        ...state,
        newsFeedData:JSON.parse(action.reult.data)
      };
    case LOAD_NEWSFEED_FAILURE:
          return {
          ...state
        };
    case UPDATE_NEWSFEED:
     return{
      ...state,
    newsFeedData:updateNewsFeedData(state.newsFeedData,action.message)
    }
    default:
    return state;

}
}
